// Pure helpers for the Shipping Fees review screen — extracted so they can be unit-tested
// with the bare jest that ships with react-scripts (no @testing-library needed).
// Shapes the edit form values into the API PATCH payload (camelCase; the w-api parser
// converts to snake_case). See the w-api Shipping_Fee_Review contract.

// A fee is flagged when the assistant AI-estimated it and it hasn't been verified yet.
export const isFlagged = record => !!(record && record.flaggedForReview)

// Filter the table rows when the "Flagged only" toggle is on.
export const filterFlagged = (rows, onlyFlagged) =>
  onlyFlagged ? (rows || []).filter(isFlagged) : rows || []

// Display an amount with its currency name, or an em dash when there is no amount.
export const formatMoney = (amount, currencyName) => {
  if (amount === null || amount === undefined || amount === '' || Number.isNaN(Number(amount))) {
    return '—'
  }
  return `${currencyName || 'USD'} ${Number(amount).toFixed(2)}`
}

// Validate a freight/insurance amount before saving (non-negative number).
export const isValidAmount = value =>
  value !== null && value !== undefined && !Number.isNaN(Number(value)) && Number(value) >= 0

// Shape the edit form values into the API PATCH payload. Currencies are not edited from this
// screen (set to USD by onboarding); only the amounts and the review flag are sent.
export const buildShippingFeePayload = values => ({
  shippingFeeAmount: Number(values.shippingFeeAmount),
  insuranceAmount: Number(values.insuranceAmount),
  flaggedForReview: !!values.flaggedForReview
})
